import { render, staticRenderFns } from "./note_edited_text.vue?vue&type=template&id=90ea1366&vue3"
import script from "./note_edited_text.vue?vue&type=script&lang=js&vue3"
export * from "./note_edited_text.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports